    
import * as React from 'react';
import styled from 'styled-components';

import { getColor, getFontSize} from '@process-advisor/process-miner/shared/theme';
import { Metrics } from '@process-advisor/process-miner/components/decompositionTree/metrics'
import { Values } from '@process-advisor/process-miner/components/decompositionTree/values'
import { TaskAttributes } from '@process-advisor/process-miner/components/decompositionTree/taskAttributes'
import { MinMaxMetric } from '@process-advisor/process-miner/components/decompositionTree/minMaxMetric'
import { MinMaxTasks } from '@process-advisor/process-miner/components/decompositionTree/minMaxTasks'
import { Typography } from '@mui/material';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events'

const Wrapper = styled.div`
    background-color: white;
    width: 800px;
    margin-left: 35px;
    margin-top: 17px;
    padding: 5px;
`;

const Row1 = styled.div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: 50px 200px 65px 400px;
  padding-bottom: 5px;
`;

const Row2 = styled.div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: 70px 130px 40px 220px 40px 220px;
  padding-bottom: 5px;
`;

const MetricLabel = styled.div`
    grid-row: 1 / 1 ;
    grid-column: 1 / 1 ;
`;

const MetricValue = styled.div`
    grid-row: 1 / 1 ;
    grid-column: 2 / 2 ;
`;

const AttributeLabel = styled.div`
    grid-row: 1 / 1 ;
    grid-column: 3 / 3 ;
`;

const AttributeValue = styled.div`
    grid-row: 1 / 1 ;
    grid-column: 4 / 4 ;
`;

const ValuesLabel = styled.div`
    grid-row: 2 / 2 ;
    grid-column: 1 / 1 ;
`;

const ValuesValue = styled.div`
    grid-row: 2 / 2 ;
    grid-column: 2 / 2 ;
`;

const TasksMinMaxLabel = styled.div`
    grid-row: 2 / 2 ;
    grid-column: 3 / 3 ;
`;

const TasksMinMaxValue = styled.div`
    grid-row: 2 / 2 ;
    grid-column: 4 / 4 ;
`;

const MetricMinMaxLabel = styled.div`
    grid-row: 2 / 2 ;
    grid-column: 5 / 5 ;
`;

const MetricMinMaxValue = styled.div`
    grid-row: 2 / 2 ;
    grid-column: 6 / 6 ;
`;


const Label = styled.div`
    font-size: ${getFontSize('smaller')};
    color: ${getColor('blue')};
`;

const Row3 = styled.div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: auto;
  padding-bottom: 10px;
  padding-bottom: 5px;
`;

export const DecompositionTree_Options = () => {
    const [description, setDescription] = React.useState<String>('');

    React.useEffect(() => {
        setDescription(apiProvider.getRCDescription());
    }, []);

    React.useEffect(() => {

        const listener = () => {
            setDescription(apiProvider.getRCDescription());
        };        
        apiProvider.on(Event.setDiagramDecompositionTree, listener);
        return () => {
            apiProvider.off(Event.setDiagramDecompositionTree, listener);

        };
    }, []);
    const label = apiProvider.getEntityUpper() + 's:'

    return (
        <Wrapper>
            <Row1>
                <MetricLabel>
                    <Label>Metric:</Label>
                </MetricLabel>
                <MetricValue>
                    <Metrics/>
                </MetricValue>
                <AttributeLabel>
                    <Label>Attributes:</Label>
                </AttributeLabel>
                <AttributeValue>
                    <TaskAttributes/>
                </AttributeValue>                
            </Row1>
            <Row2>
                <ValuesLabel>
                    <Label>Metric sort:</Label>
                </ValuesLabel>
                <ValuesValue>
                    <Values/>
                </ValuesValue>
                <TasksMinMaxLabel>
                    <Label>{label}</Label>
                </TasksMinMaxLabel>
                <TasksMinMaxValue>
                    <MinMaxTasks/>
                </TasksMinMaxValue>
                <MetricMinMaxLabel>
                    <Label>Metric:</Label>
                </MetricMinMaxLabel>
                <MetricMinMaxValue>
                    <MinMaxMetric/>
                </MetricMinMaxValue>
            </Row2>
            <Row3>
                <Typography
                    variant="caption"
                    align="center"
                    sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'system-ui'
}}
                    component="div">
                    {description}
                </Typography>
            </Row3>            
        </Wrapper>
    );
};
